import { render, staticRenderFns } from "./NoticeOfPrivacy.vue?vue&type=template&id=8880527a&"
import script from "./NoticeOfPrivacy.vue?vue&type=script&lang=js&"
export * from "./NoticeOfPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QPageContainer,QPage,QStepper,QStep,QScrollArea,QCheckbox,QDialog,QCard,QCardSection,QCardActions,QFooter,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QHeader,QToolbar,QPageContainer,QPage,QStepper,QStep,QScrollArea,QCheckbox,QDialog,QCard,QCardSection,QCardActions,QFooter})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
